import React from "react";
import { Helmet } from "react-helmet";

import Layout from "./Layout";
import PageHero from "./PageHero";
import InfoFooter from "./InfoFooter";

// The four sortiment subpages (optometrie, bryle, cocky, doplnky) were
// copies of one another in the Gatsby site. They share this template and
// differ only in the data passed in.
const ProductPage = ({
  title,
  subtitle,
  description,
  keywords,
  hero,
  heroAlt,
  centeredHeading = false,
  boxes = [],
  review,
  brands,
}) => (
  <Layout>
    <Helmet
      title={`${title} | Optika Volyně`}
      meta={[
        { name: "description", content: description },
        { name: "keywords", content: keywords },
      ]}
    />
    <main className="glasses-main">
      {centeredHeading ? (
        <div className="slider-products">
          <img
            className="sliderphoto-products"
            width={1920}
            alt={heroAlt}
            src={hero}
          />
          <div className="slider-sale-and-text-products references-heading-container">
            <h1 className="slider-sale-products references-heading">{title}</h1>
          </div>
        </div>
      ) : (
        <PageHero
          image={hero}
          alt={heroAlt}
          title={title}
          subtitle={subtitle}
        />
      )}

      <div className="bottom-site">
        <div className="boxes">
          {boxes.map((box) => (
            <div className="box" key={box.heading}>
              <img alt={box.iconAlt} src={box.icon} width={100} />
              <div className="box-desc">
                <h2>{box.heading}</h2>
                <p>{box.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="bottom-of-productpage">
        {review && (
          <div className="review product-review">
            <div className="speech-bubble-right sortiment-bubble">
              {review.text}
            </div>
            <div className="reviewer reviewer-of-product">
              <img src={review.image} alt={review.imageAlt} width={200} />
              <p>{review.name}</p>
            </div>
          </div>
        )}

        {brands &&
          brands.map((brand) => (
            <div className="brand-image" key={brand.alt}>
              <img src={brand.src} alt={brand.alt} />
            </div>
          ))}
      </div>

      <InfoFooter />
    </main>
  </Layout>
);

export default ProductPage;
